<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>ชื่อวัสดุ</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="text"
                       v-model="factorial.name"
                       disabled
                />
            </b-col>
        </b-row>
        <br>

        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>แหล่งที่มา</label>
            </b-col>
            <b-col sm="6">
                <select class="form-control mr-sm-2 w-100" disabled
                        v-model="factorial.source_id">
                    <option value="1">ในประเทศ</option>
                    <option value="2">นอกประเทศ</option>
                </select>
            </b-col>
        </b-row>
        <br>

        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>สั่งซื้อจำนวน</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="number"
                       v-model="form.quantity"
                />
            </b-col>
        </b-row>
        <br>

        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>หมายเหตุ</label>
            </b-col>
            <b-col sm="6">
                 <textarea class="form-control"
                           placeholder="หมายเหตุ"
                           v-model="form.note">
                            </textarea>
            </b-col>
        </b-row>
        <input type="hidden" />
        <br>
        <b-row>
            <div class="col text-center">
                <button type="button"
                        @click="onSubmitImportData"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>&nbsp;&nbsp;
                <button type="button"
                        @click="cancelModalImport"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <br>
<!--        <pre class="alert-primary">{{factorial}}</pre>-->
<!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "factorial-material-import-modal",
        data() {
            return {
                id: "",
            };
        },
        created() {

        },
        computed: {
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                form: state => {
                    return state.FactorialMaterialImport.form;
                },
                factorial: state => {
                    return state.FactorialMaterial.form;
                },
            })
        },
        methods:{
            onSubmitImportData() {
                if(!this.form.quantity){
                    alert('กรุณาใส่จำนวน')
                }
                else if(this.form.quantity < 1){
                    alert('กรุณาใส่จำนวนให้ถูกต้อง')
                }
                else{
                    let data = {
                        id: this.form.id,
                        factorial_id: this.factorial.id,
                        user_id : this.user.id,
                        quantity : this.form.quantity,
                        source_id : this.factorial.source_id,
                        note : this.form.note,
                    };
                    this.form.onSave = true;
                    this.$emit("submit", data);
                }
            },
            cancelModalImport(){
                this.$store.dispatch("FactorialMaterialImport/clearFormData")
                this.$emit("submit", 0);
            },
        }
    }
</script>

<style scoped>

</style>
